import { EventEmitter, Injectable } from '@angular/core'
import { Application, DashboardItem } from '@idp-education/ors-test-taker-bff-client-v1'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class StateService {
  userDetails = new BehaviorSubject({})
  closePopup: EventEmitter<boolean> = new EventEmitter<boolean>()
  private currentPageSubject = new BehaviorSubject<string | null>(null)
  public currentPage$ = this.currentPageSubject.asObservable()
  private originalApplicationSubject = new BehaviorSubject<DashboardItem | null>(null)
  public originalApplication$ = this.originalApplicationSubject.asObservable()
  private latestPageSubject = new BehaviorSubject<string | null>(null)
  public latestPage$ = this.latestPageSubject.asObservable()

  setCurrentPage (page: string): void {
    this.currentPageSubject.next(page)
  }

  setOriginalApplication (application: any): void {
    this.originalApplicationSubject.next(application)
  }

  setLatestPageUrl (latestPage: string | null): void {
    this.latestPageSubject.next(latestPage)
  }
}
